<template>
  <div class="vehicle">
    <v-container class="d-flex justify-center">
      <vehicle :vehid="this.$route.params.vehicle">
        <template v-slot:tabsright>
          <v-tab :to="{ name: 'customer-info' }">Συναλλαγες</v-tab>
          <v-tab :to="{ name: 'customer-invoices' }">Τιμολογια</v-tab>
          <v-tab :to="{ name: 'customer-quotes' }">Προσφορές</v-tab>
        </template>
      </vehicle>
      <router-view></router-view>
    </v-container>
  </div>
</template>

<script>
import Vehicle from "../components/Vehicle.vue";


export default {
  components: {
    Vehicle,
  },
  data() {
    return {
      expanded: [],
      timdialog: false,
      diaitems: {},
      loading: true,
      balance: 0.0,
      info: {
        name: "",
        address: "",
        telephone: "",
        nino: "",
        doi: "",
        city: "",
      },
      vehid: this.$route.params.vehicle,
    };
  },
  async created() {

  },
  methods: {},
};
</script>
